<template>
  <div>
    <!--div v-if="flag" style="position: absolute; width: 978px; padding-top: 250px; box-sizing: border-box; text-align: center; background: rgba(0,0,0,0.5);height: 650px; z-index: 10;">
      <xo-loader :type="'cube'" :color="['#ff3634']" :size="{width: '32px', height: '32px'}" :font="{fontSize: '12px', color: 'white'}" :text="'发送中...'"></xo-loader>
    </div-->
    <range-manip :params="rangeManpiOpts" @forCommit="getData"></range-manip>
  </div>
</template>

<script>
  import rangeManip from '@/components/byl/rangeManip/withItems.vue'
  import certService from '@/utils/sendCert'
  import msgService from '@/utils/sendMsg'
  export default {
    components: { rangeManip },
    data () {
      return {
        rangeManpiOpts: {
          name: 'range',
          outputsKey: 'outputs', // 该组件对外输出数据时，定义的key值
          editMode: true,
          tabs: ['org', 'custom']
        },
        flag: false
      }
    },
    methods: {
      getData (val) {
        var that = this
        if (val.form && val.people && val.people.length > 0 && val.form.certList && val.form.certList.length > 0) {
          // this.flag = true
          that.$toasted.show('证书已发送, 请稍后在发证记录中查询结果')
          certService.send(val).then((r) => {
            // that.$toasted.show('证书已发送, 请稍后在发证记录中查询结果' + '发送成功' + r.successNum + '张, ' + '失败' + r.failNum + '张')
            // that.flag = false
            /* val.form = {
              certList: [] // 维持原来的数据结构
            }
            val.people = [] */
          })
        } else {
          that.$toasted.show('请确保勾选了人员并选择至少一个证书模板')
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/page/byl/org/cert/send.vue